export default __webpack_public_path__ + "static/attach-d5da76b85e93d2d37aea2b1967abb47f.png";